/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Assign_TitleInputs */

const vi_reconcile_assign_title = /** @type {(inputs: Reconcile_Assign_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gán khoản CK vào đơn`)
};

/**

* @param {Reconcile_Assign_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_assign_title = /** @type {((inputs?: Reconcile_Assign_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Assign_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_assign_title(inputs)
});